import * as React from "react";
import MessageField from "views/components/messagelist/MessageField";
import FieldType from "views/logic/fieldtypes/FieldType";
import FieldTypeMapping from "views/logic/fieldtypes/FieldTypeMapping";
import { MessageDetailsDL } from "views/components/messagelist/MessageFields/MessageFieldsViewModeList";
export const DefaultMessageFields = ({ message, fields }) => {
  const formattedFields = message.formatted_fields;
  const renderedFields = Object.keys(formattedFields).sort().map((key) => {
    const { type } = fields.find((t) => t.name === key, void 0, FieldTypeMapping.create(key, FieldType.Unknown));
    return /* @__PURE__ */ React.createElement(MessageField, { key, fieldName: key, fieldType: type, message, value: formattedFields[key] });
  });
  return /* @__PURE__ */ React.createElement(MessageDetailsDL, { className: "message-details-fields" }, renderedFields);
};
export default DefaultMessageFields;
